import { rootUrl } from '@/constants';
import { getCookies } from '@/utils/cookie';
import axios from 'axios';

export type SubmitSmerMarkAllViewed = {
  user: string;
};

export const smerMarkAllViewed = async (data: SubmitSmerMarkAllViewed) => {
  const response = await axios.post(
    `${rootUrl}/psychologist/smer/mark/all/viewed`,
    {
      user: data.user,
      token: getCookies('auth'),
    }
  );

  return response.data;
};
